<template>
  <div class="c-seasons__wrapper">
    <v-dropdown
      ref="dropdown"
      activate-on-click
      class="c-seasons__dropdown"
    >
      <template #activator>
        {{ seasonTitle(season) }}
        <i class="o-icon o-icon--down o-icon--small u-color-accent"></i>
      </template>
      <template #default>
        <div
          v-for="(record) in seasons.collection.records"
          class="u-clickable"
          @click="updateSeason(record)"
        >
          {{ seasonTitle(record) }}
        </div>
      </template>
    </v-dropdown>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { useContext } from '@/shared/composables';
  import { VDropdown } from '@/index/shared/components';

  const props = defineProps({
    seasons: {
      type: Object,
      required: true,
    },
    season: {
      type: Object,
      required: true,
    },
  });
  const emit = defineEmits(['update:season']);

  const { $i18n } = useContext();

  const dropdown = ref(null);
  function updateSeason(record) {
    emit('update:season', record);
    dropdown.value.close();
  }

  const showSeasonNumber = computed(() => props.season.serial.showSeasonNumber);
  function seasonTitle(record) {
    const defaultTitle = `${$i18n.t('glossary.season')} ${record.display}`;
    return showSeasonNumber.value ? defaultTitle : record.title || defaultTitle;
  }
</script>
